import React, { Component } from "react";
//import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Translation from "../translation/translation";
import { Redirect } from "react-router-dom";
//import $ from 'jquery';
import Context from "../context/context";
import Comm from "../comm/comm";
//import moment from 'moment';
import { saveAs } from "file-saver";

class Corrections extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;
        var report = Comm.Corrections({ session: sid, lang: Translation.CurrentLanguage().toLowerCase() });
        this.state = {
            Report: report,
        };

        this.Print = this.Print.bind(this);
        this.Export = this.Export.bind(this);
    }

    Export(content) {
        var html =
            "<html><head><meta http-equiv='Content-Type' content='text/html; charset=utf-8' /></head><body>" +
            content +
            "</body></html>";
        var file = new Blob([html]);
        saveAs(file, "export.xls");
    }

    Print() {
        var mywindow = window.open("", "PRINT", "height=400,width=600");

        mywindow.document.write("<html><head><title>" + document.title + "</title>");
        if (this.state.Landscape)
            mywindow.document.write("<style>@media print {@page {size: landscape}}</style>");

        mywindow.document.write("</head><body >");
        //mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(this.state.Report.html);
        mywindow.document.write("</body></html>");
        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }
        if (Context.RenderNotOK(this.props.history)) return null;

        return Context.HasRight("rcorrections") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("editedquantities")}</div>
                <div className="panel-body">
                    <div className="col-md-12">
                        <button className="btn btn-primary" onClick={this.Print}>
                            <i className="fa fa-print"></i>
                            <p>{Translation.Trans("print")}</p>
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={() => this.Export(this.state.Report.html)}
                        >
                            <i className="fas fa-table"></i>
                            <p>{Translation.Trans("export")}</p>
                        </button>
                    </div>

                    <div
                        className="col-md-12"
                        id="dReport"
                        dangerouslySetInnerHTML={{ __html: this.state.Report.html }}
                    ></div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default Corrections;



// WEBPACK FOOTER //
// ./src/pages/corrections.js